@if (nav(); as nav) {
    <nav
        class="max-w-100vw z-1000 relative block w-full"
        [ngClass]="[open() ? 'min-h-100dvh md:min-h-10' : '', open() ? elStyle.wrapper.open : '']"
    >
        <div class="{{ open() ? elStyle.nav.mobile.wrapper : '' }}">
            <div class="relative {{ open() ? elStyle.nav.mobile.content : '' }}">
                <div
                    class="w-full"
                    [ngClass]="[
                        elStyle.nav.wrapper.default,
                        isAtLeastOnDropdownOpen() ? elStyle.nav.wrapper.open : elStyle.nav.wrapper.notOpen,
                    ]"
                >
                    <div
                        [ngClass]="[
                            'max-w-100vw w-full items-center justify-center lg:flex',
                            elStyle.meta.wrapper.default,
                            isAtLeastOnDropdownOpen() ? elStyle.meta.wrapper.open : elStyle.meta.wrapper.notOpen,
                        ]"
                    >
                        <div
                            [ngClass]="[
                                'lg:max-w-1440 relative hidden w-full items-center justify-end overflow-hidden lg:mx-auto lg:flex',
                                elStyle.meta.content.default,
                                isAtLeastOnDropdownOpen() ? elStyle.meta.content.open : elStyle.meta.content.notOpen,
                            ]"
                        >
                            <div class="flex flex-grow">
                                <a [wholesaleRouterLink]="nav.logo.link">
                                    @if (nav.logo.image && elStyle.partnerlogoInMeta) {
                                        <div class="flex-grow">
                                            <wholesale-m000-c010-image
                                                [priority]="true"
                                                [image]="{
                                                    image: nav.logo.image,
                                                    desktop: { width: 260, height: 1 },
                                                    tablet: { width: 158, height: 1 },
                                                    mobile: { width: 158, height: 1 },
                                                }"
                                                [title]="'Logo ' + dealer().name"
                                                [alt]="'Logo ' + dealer().name"
                                                [ignoreHeight]="true"
                                                [classList]="elStyle.dealer.image"
                                            />
                                        </div>
                                    }
                                    @if (!nav.logo.image && elStyle.partnerlogoInMeta) {
                                        <p class="flex-grow">{{ dealer().name }}</p>
                                    }
                                </a>
                            </div>
                            <ng-container [ngTemplateOutlet]="metanav" />
                        </div>
                    </div>
                    <div
                        class="flex items-center justify-between  w-full lg:max-w-1440 lg:mx-auto relative overflow-hidden {{
                            elStyle.nav.content
                        }}"
                    >
                        <a
                            [ngClass]="[
                                'flex items-center',
                                elStyle.nav.logo.container.default,
                                isAtLeastOnDropdownOpen()
                                    ? elStyle.nav.logo.container.open
                                    : elStyle.nav.logo.container.notOpen,
                            ]"
                            [wholesaleRouterLink]="nav.logo.link"
                        >
                            <span
                                [class]="elStyle.nav.logo.icon"
                                [svgAwesome]="elStyle.nav.logo.path"
                                [classList]="['h-full', 'w-full', 'fill-light-text']"
                                priority
                            ></span>
                            <span
                                class="{{ elStyle.nav.logo.spacer }} {{ elStyle.partnerlogoInMeta ? 'lg:hidden' : '' }}"
                            ></span>
                            @if (nav.logo.image) {
                                <span class="{{ elStyle.nav.logo.desktopWrapper }}">
                                    <wholesale-m000-c010-image
                                        class="{{ elStyle.partnerlogoInMeta ? 'lg:hidden' : '' }}"
                                        [priority]="true"
                                        [image]="{
                                            image: nav.logo.image,
                                            desktop: { width: 260, height: 1 },
                                            tablet: { width: 158, height: 1 },
                                            mobile: { width: 158, height: 1 },
                                        }"
                                        [title]="'Logo'"
                                        [alt]="'Logo'"
                                        [ignoreHeight]="true"
                                        [classList]="elStyle.dealer.image"
                                    />
                                </span>
                            }
                            @if (!nav.logo.image) {
                                <span class="{{ elStyle.partnerlogoInMeta ? 'lg:hidden' : '' }}">
                                    {{ dealer().name }}
                                </span>
                            }
                        </a>

                        <div class="{{ elStyle.nav.link.container }}">
                            @if (showMainNav()) {
                                <ng-container [ngTemplateOutlet]="mainnav" />
                            }
                        </div>
                        @if (showMainNav()) {
                            @if (elStyle.nav.languageSwitchAsString) {
                                <button
                                    class="hidden lg:flex items-center cursor-pointer justify-center {{
                                        isAtLeastOnDropdownOpen()
                                            ? elStyle.nav.icons.languageSwitch.open
                                            : elStyle.nav.icons.languageSwitch.notOpen
                                    }}"
                                    [ngClass]="[elStyle.nav.icons.languageSwitch.default]"
                                    (click)="openLanguageDialog()"
                                    aria-label="Switch language"
                                >
                                    {{ nav.language.activeLanguage }}
                                </button>
                            } @else {
                                <button
                                    class="hidden lg:flex items-center cursor-pointer justify-center {{
                                        isAtLeastOnDropdownOpen()
                                            ? elStyle.nav.icons.languageSwitch.open
                                            : elStyle.nav.icons.languageSwitch.notOpen
                                    }}"
                                    [svgAwesome]="'assets/icons/language.svg'"
                                    [priority]="true"
                                    [classList]="[elStyle.nav.icons.languageSwitch.default]"
                                    (click)="openLanguageDialog()"
                                    aria-label="Switch language"
                                ></button>
                            }
                        }

                        @if (showMainNav()) {
                            @if (open()) {
                                <button
                                    class="flex cursor-pointer items-center justify-center lg:hidden"
                                    [svgAwesome]="'assets/icons/close.svg'"
                                    [priority]="true"
                                    [classList]="[elStyle.nav.icons.burgerMenu.closed]"
                                    (click)="closeMobileNav()"
                                ></button>
                            } @else {
                                <button
                                    class="flex cursor-pointer items-center justify-center lg:hidden"
                                    [svgAwesome]="'assets/icons/burgermenu.svg'"
                                    [priority]="true"
                                    [classList]="[elStyle.nav.icons.burgerMenu.open]"
                                    (click)="openMobileNav()"
                                ></button>
                            }
                        }
                    </div>
                </div>

                @if (open() && !isAtLeastOnDropdownOpen()) {
                    <div [ngClass]="elStyle.nav.container">
                        <ng-container [ngTemplateOutlet]="mainnav" />
                    </div>
                }

                @for (navItem of nav.mainNav; track $index; let index = $index) {
                    @if ((navItem | isNavDropdown) && isAtLeastOnDropdownOpen()) {
                        @if (dropdownList()[index].open) {
                            <div [ngClass]="elStyle.nav.dropdownContent.overlay">
                                <button
                                    [ngClass]="elStyle.nav.dropdownContent.back"
                                    [svgAwesome]="
                                        elStyle.nav.link.dropdown.backIconPath ?? elStyle.nav.link.dropdown.iconPath
                                    "
                                    [classList]="['w-24', 'h-24', 'fill-inherit']"
                                    (click)="toggleDropdown(index)"
                                    priority
                                ></button>

                                <div
                                    [ngClass]="[
                                        elStyle.nav.dropdownContent.grid,
                                        navItem.items.length > 4 ? '' : 'lg:justify-center',
                                    ]"
                                >
                                    @for (subItem of navItem.items; track subItem.image) {
                                        <a
                                            class="{{ elStyle.nav.dropdownContent.link.item }}"
                                            [wholesaleRouterLink]="[subItem.url]"
                                        >
                                            @if (subItem.image) {
                                                <wholesale-m000-c010-image
                                                    class="block {{ elStyle.nav.dropdownContent.link.img }}"
                                                    [image]="{
                                                        image: subItem.image,
                                                        desktop: { width: 280, height: 162 },
                                                        tablet: { width: 280, height: 162 },
                                                        mobile: { width: 157, height: 90 },
                                                    }"
                                                    [title]="navItem.name"
                                                    [alt]="navItem.name"
                                                    [classList]="elStyle.nav.dropdownContent.link.img"
                                                    [priority]="false"
                                                />
                                            }
                                            @if (!subItem.image) {
                                                <div
                                                    class="block bg-grey-300 {{ elStyle.nav.dropdownContent.link.img }}"
                                                ></div>
                                            }
                                            <p class="flex items-center {{ elStyle.nav.dropdownContent.link.text }}">
                                                <span
                                                    class="flex-shrink-0 {{ elStyle.nav.dropdownContent.link.arrow }}"
                                                    [svgAwesome]="elStyle.nav.dropdownContent.link.iconPath"
                                                    [priority]="false"
                                                    [classList]="['w-full', 'h-full', 'fill-light-text']"
                                                ></span>
                                                <span class="flex-grow break-words">
                                                    {{ subItem.name }}
                                                </span>
                                            </p>
                                        </a>
                                    }
                                </div>

                                <div class="{{ elStyle.nav.dropdownContent.overviewLink.wrapper }}">
                                    <a
                                        class="{{ elStyle.nav.dropdownContent.overviewLink.item }}"
                                        [wholesaleRouterLink]="[navItem.overview.url]"
                                    >
                                        <span
                                            class="flex-shrink-0 {{ elStyle.nav.dropdownContent.overviewLink.arrow }}"
                                            [svgAwesome]="elStyle.nav.dropdownContent.overviewLink.iconPath"
                                            [priority]="false"
                                            [classList]="['w-full', 'h-full', 'fill-inherit']"
                                        ></span>
                                        <span>
                                            {{ navItem.overview.name }}
                                        </span>
                                    </a>
                                </div>
                            </div>
                        }
                    }
                }
            </div>
        </div>
        @if (open()) {
            <div class="absolute bottom-0 left-0 right-0">
                <div class="{{ elStyle.nav.mobile.languageSwitch.container }}">
                    <div class="{{ elStyle.nav.mobile.languageSwitch.divider }}"></div>
                    <button class="{{ elStyle.nav.mobile.languageSwitch.button }}" (click)="openLanguageDialog()">
                        <span
                            [svgAwesome]="'assets/icons/language.svg'"
                            [classList]="[elStyle.nav.mobile.languageSwitch.icon]"
                            priority
                        ></span>

                        <span class="{{ elStyle.nav.mobile.languageSwitch.text }}">
                            {{ nav.language.activeLanguageString }}
                        </span>
                    </button>
                </div>
                <div class="flex w-full lg:hidden" [ngClass]="elStyle.meta.mobile.wrapper">
                    <ng-container [ngTemplateOutlet]="metanav" />
                </div>
            </div>
        }
    </nav>

    <ng-template #mainnav>
        @for (navItem of nav.mainNav; track navItem.name; let index = $index) {
            @if (navItem | isNavDropdown) {
                <button
                    [ngClass]="[
                        elStyle.nav.link.dropdown.item.default,
                        isAtLeastOnDropdownOpen()
                            ? elStyle.nav.link.dropdown.item.open
                            : elStyle.nav.link.dropdown.item.notOpen,
                    ]"
                    (click)="toggleDropdown(index)"
                >
                    {{ navItem.name }}
                    <span
                        [ngClass]="
                            isAtLeastOnDropdownOpen()
                                ? elStyle.nav.link.dropdown.icon.open
                                : elStyle.nav.link.dropdown.icon.notOpen
                        "
                        [svgAwesome]="elStyle.nav.link.dropdown.iconPath"
                        [classList]="[elStyle.nav.link.dropdown.icon.default]"
                        priority
                    ></span>
                </button>
            } @else {
                <a
                    [ngClass]="[
                        elStyle.nav.link.default,
                        isAtLeastOnDropdownOpen() ? elStyle.nav.link.open : elStyle.nav.link.notOpen,
                        elStyle.nav.link.showIcon ? 'flex items-center justify-between' : '',
                    ]"
                    [routerLink]="navItem.url"
                    [routerLinkActive]="elStyle.nav.link.active"
                >
                    <span>{{ navItem.name }}</span>
                    @if (elStyle.nav.link.showIcon) {
                        <span
                            class="block lg:hidden"
                            [ngClass]="
                                isAtLeastOnDropdownOpen()
                                    ? elStyle.nav.link.dropdown.icon.open
                                    : elStyle.nav.link.dropdown.icon.notOpen
                            "
                            [svgAwesome]="elStyle.nav.link.dropdown.iconPath"
                            [priority]="false"
                            [classList]="[elStyle.nav.link.dropdown.icon.default]"
                        ></span>
                    }
                </a>
            }
        }
    </ng-template>

    <ng-template #metanav>
        <a
            class="flex items-center {{ elStyle.meta.item.item }} {{ elStyle.meta.item.spaceBetween }}"
            [href]="nav.contact.route.link"
            target="_blank"
        >
            <span
                class="{{ elStyle.meta.item.iconSpace }} {{
                    isAtLeastOnDropdownOpen() ? elStyle.meta.item.icon.open : elStyle.meta.item.icon.notOpen
                }}"
                [svgAwesome]="'assets/icons/marker.svg'"
                [classList]="[elStyle.meta.item.icon.default]"
                priority
            ></span>

            {{ nav.contact.route.text }}
        </a>

        <a
            class="flex items-center {{ elStyle.meta.item.item }} {{ elStyle.meta.item.spaceBetween }}"
            target="_blank"
            href="mailto:{{ nav.contact.email.link }}"
        >
            <span
                class="{{ elStyle.meta.item.iconSpace }} {{
                    isAtLeastOnDropdownOpen() ? elStyle.meta.item.icon.open : elStyle.meta.item.icon.notOpen
                }}"
                [svgAwesome]="'assets/icons/mail.svg'"
                [classList]="[elStyle.meta.item.icon.default]"
                priority
            ></span>

            {{ nav.contact.email.text }}
        </a>

        @if (phoneNumber(); as phoneNumber) {
            <a
                class="flex items-center {{ elStyle.meta.item.item }} {{ elStyle.meta.item.phoneItem }}"
                target="_blank"
                href="tel:{{ phoneNumber }}"
            >
                <span
                    [ngClass]="[
                        elStyle.meta.item.iconSpace,
                        isAtLeastOnDropdownOpen() ? elStyle.meta.item.icon.open : elStyle.meta.item.icon.notOpen,
                    ]"
                    [svgAwesome]="elStyle.meta.item.iconPath"
                    [classList]="[elStyle.meta.item.icon.default]"
                    priority
                ></span>

                @if (nav.contact.phone.desktopText) {
                    <span class="hidden lg:block">{{ nav.contact.phone.desktopText }}&nbsp;</span>
                }

                <span class="hidden lg:block {{ elStyle.meta.item.phoneNumberDesktop }}">
                    {{ phoneNumber }}
                </span>

                <span class="lg:hidden">
                    {{ nav.contact.phone.text }}
                </span>
            </a>
        }
    </ng-template>
}
